export default {
	contracts: 'contratos',
	delivery: 'entrega',
	'add-contract': 'Agregar contrato',
	'edit-contract': 'Editar contrato',
	
	'add-delivery': 'Agregar entrega',
	'edit-delivery': 'Editar entrega',
	'preview-delivery': 'Vista previa de entrega',
	deliver: 'Entregar',
	'cancel-delivery': 'Cancelar entrega',

	all: 'Todos',
	'not-completed': 'No completado',
	completed: 'Completado',
	other: 'Otro',

	total: 'Total',
	'total-sales': 'Ventas totales',
	'sale-balance': 'Cantidad esperada',
	'remaining-qty': 'Cantidad de inventario',
	'available-to-sell': 'Capaz de vender',
	'are-you-sure-the-contract-is-complete': '¿Estás seguro de que el contrato está completo?',
	'mark-as-completed': 'Marcar como completado',
	'mark-as-incomplete': 'Marcar como incompleto',
	'are-you-sure-the-contract-is-incomplete': '¿Estás seguro de que el contrato está incompleto?'
}